module.exports = {
	EventTarget : require('./lib/EventTarget'),
	Event       : require('./lib/Event')
};



//////////////////
// WEBPACK FOOTER
// ./~/yaeti/index.js
// module id = 166
// module chunks = 0 1 2 3